import { Service } from '@angular/core';
import { State } from '@ngxs/store';
import { CollectionDataServiceBase } from '@portal-core/data/collection/services/collection-data.service.base';
import { CollectionStateBase } from '@portal-core/data/collection/services/collection-state.base';
import { CollectionStateSelectors } from '@portal-core/data/collection/services/collection-state-selectors.decorator';
import { WebhookSubscriber } from '@portal-core/slack/models/webhook-subscriber.model';

// Webhook Subscriber
@CollectionStateSelectors({
  stateType: WebhookSubscribersState
})
@State<WebhookSubscribersState>({
  name: WebhookSubscribersState.source
})
@Service({ autoProvided: false })
export class WebhookSubscribersState extends CollectionStateBase {
  static override source = 'WebhookSubscribers';
  getSource(): string {
    return WebhookSubscribersState.source;
  }
}

@Service()
export class SlackWebhookSubscribersDataService extends CollectionDataServiceBase<WebhookSubscriber> {
  protected readonly stateType = WebhookSubscribersState;
}
